import btnStyle from '@/components/Shares/Button.module.css';
import inputStyle from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Badge, Button, Card, Flex, Group, Input, Stack, Text, Transition } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import classes from './AccountInfo.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { useState } from 'react';
import { PhoneSelected } from './PhoneSelected';
export const InfoPhoneCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    ref,
    focused
  } = useFocusWithin();
  const {
    verify
  } = useVerifyProfile();
  const {
    setOpenModal
  } = useModalAction();
  const [phone, setPhone] = useState<string | undefined>(undefined);
  return <Card h="100%" radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }} style={{
    overflow: 'visible'
  }}>
      <Stack gap={0} py={{
      base: 10,
      sm: 12
    }}>
        <Group gap={10} align="center">
          <Text fz={{
          base: 14,
          sm: 18
        }} className={gunterzBold.className}>
            {i18n._('Phone number')}
          </Text>
          {verify && <Badge size="md" variant="light" radius={5} mb={5} classNames={{
          root: classes.badge
        }}>
              {i18n._('Verified')}
            </Badge>}
        </Group>

        <Stack gap={10} mt={24}>
          <Text fz={12} tt="uppercase" fw={700} c="var(--text-color-dark-theme)">
            {i18n._('Verify your phone number and you can use the phone as your second login method.')}
          </Text>
          <Flex direction={{
          base: 'column',
          sm: 'row'
        }} w="100%" gap={10}>
            <Group gap={10} w="100%">
              <PhoneSelected />

              <Input flex={1} ref={ref} value={phone} onChange={event => setPhone(event.currentTarget.value)} classNames={{
              input: inputStyle.input_style_2
            }} placeholder={i18n._('Enter phone number')} />
            </Group>

            <Transition mounted={focused} transition="fade-left" duration={250} timingFunction="ease">
              {styles => verify ? <Button style={styles} h={40} w={170} ml="auto" classNames={{
              root: btnStyle.button_style_2
            }}>
                    {i18n._('Change Number')}
                  </Button> : <Button style={styles} h={40} w={120} fz={11} ml="auto" classNames={btnStyle} onClick={() => setOpenModal(MODAL.VERIFY_EMAIL)}>
                    {i18n._('Send Code')}
                  </Button>}
            </Transition>
          </Flex>
        </Stack>
      </Stack>
    </Card>;
};